import { render, staticRenderFns } from "./specs-cart-heading.vue?vue&type=template&id=a65c3b12&scoped=true&v-slot%3Aspecs-heading=true&"
import script from "./specs-cart-heading.vue?vue&type=script&lang=js&"
export * from "./specs-cart-heading.vue?vue&type=script&lang=js&"
import style0 from "./specs-cart-heading.vue?vue&type=style&index=0&id=a65c3b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65c3b12",
  null
  
)

export default component.exports